/*
 * @Author: WUJUN
 * @Date: 2019-09-03 18:53:40
 * @LastEditTime: 2019-10-31 17:55:21
 * @LastEditors: WUJUN
 * @Description: 动态创建组件
 */

import Vue from 'vue';
import store from '@/store';
/**
 * @description: 
 * @param {store}共享 store 
 * @param {path} 模板路径 
 * @param {type} 模板基础路径 1：按钮控件;  2：动态页面静态弹框
 * @return: 
 */
export const _createInstance = function (path) {
  console.log('path: ', path);
  return new Promise((resolve, reject) => {
    let component = import('@/components/dialog' + path + '.vue')
    component.then((component) => {
      const ImportConstructor = Vue.extend(component.default);
      // 生成一个该子类的实例
      const instance = new ImportConstructor();
      instance.$store = store;
      instance.$mount(document.createElement('div'));
      document.body.appendChild(instance.$el);
      resolve(instance);
    }).catch(e => {
      console.log('e: ', e);
      reject(e)
    })
  })

}


// WEBPACK FOOTER //
// src/components/dialog/base.js